
import { IPowderTypeFilter } from "../models/filters/powderTypeFilter";
import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IPowderTypeForm } from "../models/forms/powderTypeForm";
import { IPowderTypePDTO } from "../models/dtos/powderTypePDTO";


export default class PowderTypeService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/PowderTypes";

    protected static override  getUrlFilter<F extends IPowderTypeFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {

        }
        
        return url;
    }

    protected static override toDTO(obj:IPowderTypeForm):IPowderTypePDTO {
        const dto = super.toDTO(obj) as IPowderTypePDTO;
        return dto;
    }
}